import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideMemberDelete: React.FC = () => {
  return (
    <GuidePageLayout
      title="要員を削除する"
      description="不要になった要員を削除します（退職・契約終了等）。"
      breadcrumbs={[{ label: '要員管理', path: '/guide/member/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
            ['対象要員', '存在すること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '要員管理画面を開く' },
            { label: '要員一覧から対象要員を検索・選択する' },
            {
              label: '詳細画面のフッターにある「削除」ボタンを押下する',
              content: (
                <GuideMockContainer label="フッターボタン（詳細表示時）">
                  <GuideMockButton label="削除" color="error" startIcon={<DeleteIcon />} />
                </GuideMockContainer>
              ),
            },
            { label: '削除確認ダイアログで「実行」ボタンを押下する' },
          ]}
        />
      </GuideSection>

      <GuideSection title="削除確認ダイアログ">
        <GuideInfoBox>
          確認ダイアログで警告メッセージが表示されます。内容を確認してから「実行」ボタンを押下してください。
        </GuideInfoBox>
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>物理削除ではなく論理削除のため、データは残ります。</GuideInfoBox>
          <GuideInfoBox type="warning">削除後は更新不可になります。</GuideInfoBox>
          <GuideInfoBox>「削除済みを含む」チェックで再表示は可能です。</GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideMemberDelete;
